
import { supabase } from "@/integrations/supabase/client";
import { handleServiceError, withErrorHandling } from "../utils/errorHandling";

export interface ConsolidatedProfileData {
  // Profile data
  profile_id: string;
  first_name: string;
  last_name: string;
  family_role: string;
  registration_family_id: string;
  current_family_id: string | null;
  invite_code: string | null;
  created_at: string;
  updated_at: string;
  
  // Family admin data
  is_family_admin: boolean;
  family_admin_id: string | null;
  family_admin_first_name: string | null;
  family_admin_last_name: string | null;
  
  // Family membership data - using Json type to match database return
  family_members: any[]; // This will be parsed JSON array
  is_single_member_family: boolean;
  
  // Family management data
  can_switch_family: boolean;
  switch_family_warning: string | null;
}

/**
 * Service for fetching consolidated profile data in a single API call
 */
export const profileConsolidatedService = {
  /**
   * Get all profile-related data in a single optimized query
   */
  getConsolidatedProfileData: withErrorHandling(
    async (userId: string): Promise<ConsolidatedProfileData | null> => {
      console.log('Fetching consolidated profile data for user:', userId);
      
      const { data, error } = await supabase
        .rpc('get_consolidated_profile_data', { 
          p_user_id: userId 
        })
        .single();
      
      if (error) {
        console.error('Error fetching consolidated profile data:', error);
        throw error;
      }
      
      if (!data) {
        console.log('No consolidated profile data found for user:', userId);
        return null;
      }
      
      // Parse the family_members JSON if it exists
      const parsedData = {
        ...data,
        family_members: typeof data.family_members === 'string' 
          ? JSON.parse(data.family_members) 
          : data.family_members || []
      };
      
      console.log('Consolidated profile data fetched successfully:', parsedData);
      return parsedData;
    },
    "Error fetching consolidated profile data"
  )
};
